// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1jURW","detailsBorder":"styles_detailsBorder___7XjM"};